import { render } from "./LocaleToggle.vue?vue&type=template&id=13a0b717&scoped=true"
import script from "./LocaleToggle.vue?vue&type=script&lang=js"
export * from "./LocaleToggle.vue?vue&type=script&lang=js"

import "./LocaleToggle.vue?vue&type=style&index=0&id=13a0b717&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a0b717"]])

export default __exports__